module.exports = __webpack_public_path__ + "static/media/sandy18.854af1ab.png";